import React from 'react';

const Card = ({ as: Component = 'article', className = '', children }) => {
  const classes = ['c-card', className].filter(Boolean).join(' ');

  return <Component className={classes}>{children}</Component>;
};

export default Card;
